import { useRouter } from 'vue-router'
import { ref, reactive, watch, onBeforeMount, onMounted, computed } from 'vue';
import Button from '@//components/ui/button/index.vue';
import Table from '@//components/ui/tablebox/index.vue';
import TableInfo from '@//components/ui/tableinfo/index.vue';
import Select from '@//components/ui/select/index.vue';
import CTmenu from '@//components/ui/ctmenu/index.vue';
import Pagination from '@//components/ui/pagination/index.vue';
import ActionBar from '@//components/ui/actionbar/index.vue';
import { ACTIONBAR, FEATURENAME, POPUP, BTN, CONNECTION } from '@//enum/enum';
import { useStore } from 'vuex';
import { apiGetDevice, apiGetGroupModel, apiDeleteDevice, apiCSV } from '@/api/api';
import { dateTimeHandle } from '@/utils/time';
import {useI18n} from 'vue-i18n';

export default {
  name: 'device',
  components: {
    Button,
    Select,
    Table,
    TableInfo,
    CTmenu,
    Pagination,
    ActionBar
  },
  props: {
    // tabText:{

    // }
  },
  setup() {

    const hoverDiv = ref();
    let target = null;
    const { t,locale } = useI18n();

    const state = reactive({
      detail:'',
      left: null,
      top: null,
      meta: {
        total_page: 1,
        current: 1,
        per_page: 12,
      },

      op1: [
        {
          text: t('__d7d_n17r.__allDevices'),
          val: '',
          isI18n : '__d7d_n17r.__allDevices',
        },
        {
          text: t('__common.__model'),
          val: 'model',
          isI18n : '__common.__model',
          sub: []
        },
        {
          text: t('__d7d_n17r.__connectionStatus'),
          val: 'status',
          isI18n : '__d7d_n17r.__connectionStatus',
          sub: [
            {
              text: t('__g3p_m8t.__online'),
              val: '1',
              group: 'status',
              isI18n : '__g3p_m8t.__online',
            },
            {
              text: t('__g3p_m8t.__offline'),
              val: '0',
              group: 'status',
              isI18n : '__g3p_m8t.__offline',
            },
            {
              text: t('__d7d_n17r.__waitingForReply'),
              val: '2',
              group: 'status',
              isI18n : '__d7d_n17r.__waitingForReply',
            },
          ]
        },
      ],
      selectVal1: {
        text: t('__d7d_n17r.__allDevices'),
        val: '',
        isI18n : '__d7d_n17r.__allDevices',
      },
      showColumn:[],
      column: [], //因應國語系廢棄
      dataList: [],
      iconList: [
        {
          title: t('__d4e_m8t.__setCalibration'),
          name: 'asus_proart_sw_ico_control_settings',
          val: ACTIONBAR.SETCAL,
          disabled: true,
          isI18n : '__d4e_m8t.__setCalibration',
          gtmId : '__setCalibrationDeviceIcon',
        },
        {
          title: t('__d4e_m8t.__viewHistory'),
          name: 'asus_pacc_sw_ico_history',
          val: ACTIONBAR.VIEWHIS,
          disabled: true,
          isI18n : '__d4e_m8t.__viewHistory',
          gtmId : '__viewHistoryDeviceIcon',
        },
        {
          title: t('__d4e_m8t.__viewAppointment'),
          name: 'asus_pacc_sw_ico_appointment',
          val: ACTIONBAR.VIEWAPP,
          disabled: true,
          isI18n : '__d4e_m8t.__viewAppointment',
          gtmId : '__viewAppointmentDeviceIcon',
        },
        {
          title: t('__d4e_m8t.__settings'),
          name: 'asus_proart_sw_ico_settings',
          val: ACTIONBAR.SETTING,
          disabled: true,
          isI18n : '__d4e_m8t.__settings',
          gtmId : '__settingsDeviceIcon',
        },
        {
          title: t('__d4e_m8t.__downloadCsv'),
          name: 'asus_proart_sw_ico_download',
          val: ACTIONBAR.DOWNLOAD,
          disabled: true,
          isI18n : '__d4e_m8t.__downloadCsv',
          gtmId : '__downloadCsvDeviceIcon',
        },
      ],
    ctList: [
        {
          title: t('__d4e_m8t.__setCalibration'),
          name: 'asus_proart_sw_ico_control_settings',
          val: ACTIONBAR.SETCAL,
          disabled: true,
          isI18n : '__d4e_m8t.__setCalibration',
          gtmId : '__setCalibrationCTDevice',
        },
        {
          title: t('__d4e_m8t.__viewHistory'),
          val: ACTIONBAR.VIEWHIS,
          disabled: true,
          isI18n : '__d4e_m8t.__viewHistory',
          gtmId : '__viewHistoryCTDevice',
        },
        {
          title: t('__d4e_m8t.__viewAppointment'),
          val: ACTIONBAR.VIEWAPP,
          disabled: true,
          isI18n : '__d4e_m8t.__viewAppointment',
          gtmId : '__viewHistoryCTDevice',
        },
        {
          title: t('__d4e_m8t.__settings'),
          val: ACTIONBAR.SETTING,
          disabled: true,
          isI18n : '__d4e_m8t.__settings',
          gtmId : '__settingsCTDevice',
        },
        {
          title: t('__d4e_m8t.__downloadCsv'),
          val: ACTIONBAR.DOWNLOAD,
          disabled: true,
          isI18n : '__d4e_m8t.__downloadCsv',
          gtmId : '__downloadCsvCTDevice',
        },
        {
          title: t('__d4e_m8t.__unbind'),
          val: ACTIONBAR.UNBIND,
          disabled: true,
          isI18n : '__d4e_m8t.__unbind',
          gtmId : '__unbindCTDevice',
        },
      ],
      list: [],
      order: 'asc',///asc
      sort: 'bound_at',
      listTotal: null,
      disableCheck:[]
    })

    const route = useRouter()
    const fatherLink = route.currentRoute.value.fullPath

    onMounted(() => {
      target = hoverDiv.value;
      state.left = target.getBoundingClientRect().x;
      state.top = target.getBoundingClientRect().y;
      state.showColumn = colComputed.value; //原本用state.column
    })

    
    onBeforeMount(() => {
      queryModels()
      getData();
    })

    const itemClass = computed(
      () => {
        return {
          top: `${state.top + 50}px`,
          left: `${state.left}px`
        }
      }
    )





    //$i18n
    watch(
      () => locale,
      () => {
        orgDT()
      },
      { deep: true }
    )

    const orgDT = () => {
      let list =  colComputed.value
      for (let i = 0; i < list.length; i++) {
        for (let j = 0; j < state.showColumn.length; j++) {
          if(list[i].key == state.showColumn[j].key){
            state.showColumn[j].title = list[i].title
          }
        }
      }
    }

    

    const colComputed = computed(
      () => {
        let list =  [
          {
            title: t('__d7d_n17r.__modelName'),
            key: "model",
            isLink: true,
            sort: true,
            linkRestrict: 'linkFlag',
          },
          {
            title: t('__d7d_n17r.__serialNumber'),
            key: "ssn",
            sort: true,
          },
          {
            title: t('__d7d_n17r.__pcName'),
            key: "host",
            sort: true,
          },
          {
            title: t('__d7d_n17r.__connectionStatus'),
            key: "status",
            color: true,
            sort: true,
            colorEnum:
            {
              0: CONNECTION[0],
              1: CONNECTION[1],
              2: CONNECTION[2],
            },
            isI18n:
            {
              0: '__g3p_m8t.__offline',
              1: '__g3p_m8t.__online',
              2: '__g3p_m8t.__waiting',
            },
          },
          {
            title: t('__d7d_n17r.__ipAddress'),
            key: "ip",
            sort: true,
          },
          {
            title: t('__common.__group'),
            key: "group",
            width: '7%',
            sort: true,
          },
          {
            title: t('__d4e_m8t.__lastCalibrationDate'),
            key: "calibration",
            sort: true,
          },
          {
            title: t('__d4e_m8t.__addDate'),
            key: "bound_at",
            sort: true,
          },
          {
            title: t('__d4e_m8t.__taskExecutedCount'),
            key: "task_executed_count",
            color: true,
            sort: true,
            colorRange:
            {
              0: 'general',
              44: 'caution',
              49: 'limit',
            },
          },
          {
            title: t('__d4e_m8t.__appointmentCount'),
            key: "appointment_count",
            color: true,
            sort: true,
            colorRange:
            {
              0: 'general',
              74: 'caution',
              79: 'limit',
            },
          },
        ]
        return list
      }
    )

    const showEx = (e,v) => {
      state.left = e.target.getBoundingClientRect().left;
      state.top = e.target.getBoundingClientRect().top;
      if(v){
        state.detail = t('__popup.__tableItemFiliter')
      }else{
        state.detail = '';
      }
    }

    const setTableSort = () => {
      let tableCheckList = colComputed.value.map((e)=>{ //原本用state.column
        let flag = false;
        let isDisabled = false;
        console.log()
        for (let k = 0; k < state.showColumn.length; k++) {
          if(e.key === state.showColumn[k].key){
            flag = true;
          }
        }
        if(e.key == 'model' || e.key == 'ssn'){
          isDisabled = true;
        }

        return {
          ...e, val: flag, disabled :isDisabled,
        } 
      })


      console.log('title RRR',tableCheckList)
      const modalConfig = {
        type: POPUP.DEVICETABLEFILTER,
        data: {
          list: tableCheckList,
          action: true
        },
        isShow: true,
      }
      store.commit('setIsShowModal', modalConfig)
    }

    const getData = async () => {
      let selectResult = false;
      console.log(state.selectVal1.val)
      if(state.selectVal1.val == '1' || state.selectVal1.val == '0' || state.selectVal1.val == '2'){
        selectResult = false
      }else{
        selectResult = true
      }
      const sendData = {
        page: state.meta.current,
        model: selectResult? state.selectVal1.val : undefined,
        order: state.order,
        sort: state.sort,
        status: selectResult?  undefined : state.selectVal1.val,
        per_page: state.meta.per_page,
      }
      try {
        const datas = await apiGetDevice(sendData);
        console.log('device', datas)
        if (!datas.status_code) {
          for (let i = 0; i < datas.data.length; i++) {
            datas.data[i].linkFlag = datas.data[i].status == 2? false : true; //status 2 就是waiting，waiting不能點連結
            if(datas.data[i].bound_at){
              datas.data[i].bound_at = dateTimeHandle(datas.data[i].bound_at);
            }else{
              datas.data[i].bound_at = ''
            }
            if(datas.data[i].calibration){
              datas.data[i].calibration = dateTimeHandle(datas.data[i].calibration);
            }else{
              datas.data[i].calibration = ''
            }
            if(datas.data[i].group){
              let temp  = ''
              for (let j = 0; j < datas.data[i].group.length; j++) {
                temp += datas.data[i].group[j] + '; '
              }
              datas.data[i].group = temp
            }
          }
          state.dataList = datas.data;
          state.disableCheck = state.dataList.map((e)=>{
            return !e.linkFlag
          })
          state.meta.current = datas.current_page;
          state.meta.total_page = datas.last_page;
          state.meta.per_page = datas.per_page;
          state.listTotal = datas.total
        }
      }
      catch (error) {
        return error;
      }
    }

    watch(  //觀測勾選項目
      () => state.list,
      (val) => {
        if (val.length > 0) { // action bar

          if (val.length > 1 || val.length < 1) {
            for (let i = 0; i < state.iconList.length; i++) {
              if (i == 1 || i == 2 || i == 3) {
                state.iconList[i].disabled = true
              }
              else {
                state.iconList[i].disabled = false
              }
            }
          }
          else {
            for (let i = 0; i < state.iconList.length; i++) {
              state.iconList[i].disabled = false
            }
          }
        } else {
          for (let i = 0; i < state.iconList.length; i++) {
            state.iconList[i].disabled = true
          }
        }
        //ctList
        if (val.length > 0) { // action bar

          if (val.length > 1 || val.length < 1) {
            for (let i = 0; i < state.ctList.length; i++) {
              if (i == 1 || i == 2 || i == 3) {
                state.ctList[i].disabled = true
              }
              else {
                state.ctList[i].disabled = false
              }
            }
          }
          else {
            for (let i = 0; i < state.ctList.length; i++) {
              state.ctList[i].disabled = false
            }
          }
        } else {
          for (let i = 0; i < state.ctList.length; i++) {
            state.ctList[i].disabled = true
          }
        }

      },
      { deep: true }
    )




    const queryModels = async () => {
      try {
        const datas = await apiGetGroupModel();
        if (!datas.status_code) {
          let arr = [];
          for (let j = 0; j < datas.model.length; j++) {
            arr.push({ text: datas.model[j], val: datas.model[j] })
            state.op1[1].sub = arr
          }
        }
      }
      catch (error) {
        return error;
      }
    }


    const selectChange = (v) => {
      if (v) {
        state.meta.current = 1;
        getData()
      }
    }


    


    


    const geCVS = async()=>{
      let id = [];
      id = state.list.map((e)=>{
        return e.id
      })
      const sendData = {
        id: id,
      }
      try {
        const datas = await apiCSV(sendData);
        // console.log('apiCSV', datas)
        let date = dateTimeHandle(new Date(),"YYYYMMDD_HHmm","YYYYMMDD_HHmm")
        const url = window.URL.createObjectURL(new Blob([datas]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', `${date}.csv`);
        document.body.appendChild(link);
        link.click();
      }
      catch (error) {
        return error;
      }
    }



    const actionBarClick = (v) => {  //ctList
      // console.log(v,'actionBar Click')
      if (v == ACTIONBAR.SETTING || v == ACTIONBAR.VIEWAPP || v == ACTIONBAR.VIEWHIS) {
        toLink(v)
      } else if (v == ACTIONBAR.SETCAL) {
        toCalibration()
      } else if(v == ACTIONBAR.DOWNLOAD){
        geCVS()
      } else if(v == ACTIONBAR.UNBIND){
        unbind()
      }
    }

    const toCalibration = () => {
      let result = state.list.every(val => val.model === state.list[0].model); //判別是不是同一個model底下的裝置
      console.log(state.list)
      if(result){
        store.commit('setCalibrationList', {content:state.list, title: 'device'});
        console.log(store.state.calibrationList)
        route.push({ name: FEATURENAME.CALIBRATION});
      }else{
        const modalConfig = {
          type: POPUP.DEVICEMODELERROR,
          data: {},
          isShow: true,
        }
        store.commit('setIsShowModal', modalConfig)
      }

    }


    const changePage = (page) => {
      // console.log('uu',page)
      state.meta.current = page;
      getData()
    }
    const tableSort = (v) => {
      // console.log(v,'sort table')
      state.order = v.val === 'up' ? 'asc' : 'desc';
      state.sort = v.key;
      getData()
    }

    const onCheckAll = (v) => {
      // console.log(v, 'table onCheck All')
      state.list = v
    }

    const onCheckEach = (v) => {
      // console.log(v, 'table onCheck Each')
      state.list = v
    }

    const goTableLink = (v) => {
      console.log(v, 'table link')
      route.push(`${fatherLink}/${v.val.id}/${ACTIONBAR.VIEWHIS}`);
    }

    const showCTAndRow = (v) => {
      // console.log(v,'show ??? ContextMenu')
      state.list = v.list
    }

    const selectCT = (v) => {
      // console.log(v)
      actionBarClick(v.val)
    }


    const toLink = (v) => {

      route.push(`${fatherLink}/${state.list[0].id}/${v}`);
    }

    //modal

    // const store = useStore()
    // const storeState = store.state;

    const unbind = () => {
      const modalConfig = {
        type: POPUP.DEVICEUNBIND,
        data: {
          list: state.list,
          action: true
        },
        isShow: true,
      }
      store.commit('setIsShowModal', modalConfig)
    }

    const store = useStore()
    const storeState = store.state;

    store.watch((state) => (state.isShowModal, state.modalType), (newType, oldType) => {
      // modal type
      if (oldType === POPUP.DEVICEUNBIND) {
        if ((storeState.modalBtnType).indexOf(BTN.CONFIRM) > -1) {
          const output = storeState.modalOutput;
          // console.log(output,'output')
          deleteGroup(output)
        }
      }else if (oldType === POPUP.DEVICETABLEFILTER) {
        console.log('storeState.modalBtnType', storeState.modalBtnType);
        // modal btn type 決定要幹嘛
        if ((storeState.modalBtnType).indexOf(BTN.CONFIRM) > -1) {
          const output = storeState.modalOutput;
          let temp  = output.filter((e)=>{
            return e.val;
          })
          state.showColumn = temp;
          console.log("check box ",temp)
        }
      } 
    })

    const deleteGroup = async (output) => {
      const sendData = {
        id: output.arr,
      }
      try {
        const datas = await apiDeleteDevice(sendData);
        console.log('apiDeleteDevice', datas)

        getData()
        state.list.splice(0,state.list.length)
      }
      catch (error) {
        return error;
      }

    }


    //modal




    return {
      state,
      tableSort,
      onCheckAll,
      onCheckEach,
      goTableLink,
      showCTAndRow,
      selectCT,
      changePage,
      actionBarClick,
      unbind,
      toLink,
      getData,
      queryModels,
      selectChange,
      toCalibration,
      deleteGroup,
      geCVS,
      showEx,
      hoverDiv,
      itemClass,
      setTableSort,
      t,
      colComputed,
      orgDT,      
    }
  }// end: setup

}




// import { apiGetDevice } from '@/api/api';
// import { onMounted } from 'vue';
// export default {
//   components: {},
//   props: [],
//   setup() {
//     //取得資料
//     const getData = async () => {
//       const datas = await apiGetDevice();
//       console.log('datas', datas);
//     }
//     onMounted(() => {
//       getData();
//     })

//     return {
//       getData,
//     }
//   }
// }
